
import * as React from "react";
import { ComboBox, Dropdown, TextField } from "@fluentui/react";
import { Col, Row } from "reactstrap";
import * as commonCode from "./RequestCommonCode";
import { comboBoxStyles, stylesComboBoxSupressDisabledLookFN, stylesTextFieldSupressDisabledLookFN } from "../../CommonStyles";
import { IFormField } from "../../CommonTypes";
import { IRequestCommonProps } from "./RequestCommonProps";
import { IRequestCommonState } from "./RequestCommonState";

export function BaseDataFragment(this: React.Component<IRequestCommonProps, IRequestCommonState>) {
    return (
        <React.Fragment>
            <Row>
              <Col md="12" style={{ textAlign: "left" }}>
                <h5>Antragsteller</h5>
              </Col>
            </Row>
            <Row>
              <Col md="6">
                <ComboBox
                  id="AntragstellerFirma"
                  label={this.props.formFields.find(f => f.Id === "AntragstellerFirma").Label}
                  // label="Antragsteller Firma"
                  allowFreeform={this.state.companyAllowFreeform}
                  autoComplete={this.state.companyAllowFreeform ? "on" : "off"}
                  options={this.state.AntragstellerFirmaOPS}
                  selectedKey={this.state.currentRecord.AntragstellerFirma}
                  text={this.state.currentRecord.AntragstellerFirma}
                  disabled={this.state.formReadOnly}
                  // styles={comboBoxStyles}
                  styles={stylesComboBoxSupressDisabledLookFN(this.state.formReadOnly)}
                  autofill={{
                    onInputChange: commonCode.onInputChangeComboBoxFirma.bind(this)
                  }}
                  onChange={commonCode.onChangeAntragstellerFirma.bind(this)}
                  required
                  errorMessage={this.state.currentRecordErrors.AntragstellerFirma}
                  onBlur={commonCode.ValidateOnBlur.bind(this)}
                />
              </Col>
              <Col md="4">
                <TextField
                  id="Betrieb"
                  label={this.props.formFields.find(f => f.Id === "Betrieb").Label}
                  // label="Betrieb"
                  value={this.state.currentRecord.Betrieb}
                  styles={stylesTextFieldSupressDisabledLookFN(this.state.formReadOnly)}
                  maxLength={50}
                  autoComplete={this.props.autoCompleteMode}
                  disabled={this.state.formReadOnly}
                  onChange={commonCode.onChangeTextBoxBasic.bind(this)}
                />
              </Col>
              <Col md="2">
                <TextField
                  id="Gebaeude"
                  label={this.props.formFields.find(f => f.Id === "Gebaeude").Label}
                  // label="Gebäude"
                  value={this.state.currentRecord.Gebaeude}
                  styles={stylesTextFieldSupressDisabledLookFN(this.state.formReadOnly)}
                  maxLength={8}
                  autoComplete={this.props.autoCompleteMode}
                  disabled={this.state.formReadOnly}
                  onChange={commonCode.onChangeTextBoxBasic.bind(this)}
                  required
                  errorMessage={this.state.currentRecordErrors.Gebaeude}
                  onBlur={commonCode.ValidateOnBlur.bind(this)}
                />
              </Col>
            </Row>
            <Row>
              <Col md="3">
                <TextField
                  id="AntragstellerVorname"
                  label={this.props.formFields.find(f => f.Id === "AntragstellerVorname").Label}
                  // label="Antragsteller Vorname"
                  value={this.state.currentRecord.AntragstellerVorname}
                  styles={stylesTextFieldSupressDisabledLookFN(this.state.formReadOnly)}
                  maxLength={50}
                  required
                  disabled={this.state.formReadOnly}
                  autoComplete={this.props.autoCompleteMode}
                  onChange={commonCode.onChangeTextBox_NameFld.bind(this)}
                  errorMessage={this.state.currentRecordErrors.AntragstellerVorname}
                  onBlur={commonCode.ValidateOnBlur.bind(this)}
                />
              </Col>
              <Col md="3">
                <TextField
                  id="AntragstellerNachname"
                  label={this.props.formFields.find(f => f.Id === "AntragstellerNachname").Label}
                  // label="Antragsteller Nachname"
                  value={this.state.currentRecord.AntragstellerNachname}
                  styles={stylesTextFieldSupressDisabledLookFN(this.state.formReadOnly)}
                  maxLength={50}
                  autoComplete={this.props.autoCompleteMode}
                  required
                  disabled={this.state.formReadOnly}
                  onChange={commonCode.onChangeTextBox_NameFld.bind(this)}
                  errorMessage={this.state.currentRecordErrors.AntragstellerNachname}
                  onBlur={commonCode.ValidateOnBlur.bind(this)}
                />
              </Col>
              <Col md="4">
                <TextField
                  id="AntragstellerEmail"
                  label={this.props.formFields.find(f => f.Id === "AntragstellerEmail").Label}
                  // label="Antragsteller E-Mail"
                  value={this.state.currentRecord.AntragstellerEmail}
                  styles={stylesTextFieldSupressDisabledLookFN(this.state.formReadOnly)}
                  maxLength={50}
                  required
                  autoComplete={this.props.autoCompleteMode}
                  disabled={this.state.formReadOnly}
                  onChange={commonCode.onChangeTextBox_EmailFld.bind(this)}
                  errorMessage={this.state.currentRecordErrors.AntragstellerEmail}
                  onBlur={commonCode.ValidateOnBlur.bind(this)}
                />
              </Col>
              <Col md="2">
                <TextField
                  id="AntragstellerTelefon"
                  label={this.props.formFields.find(f => f.Id === "AntragstellerTelefon").Label}
                  // label="Antragsteller Telefon"
                  value={this.state.currentRecord.AntragstellerTelefon}
                  styles={stylesTextFieldSupressDisabledLookFN(this.state.formReadOnly)}
                  autoComplete={this.props.autoCompleteMode}
                  required
                  disabled={this.state.formReadOnly}
                  onChange={commonCode.onChangeTextBox_PhoneFld.bind(this)}
                  errorMessage={this.state.currentRecordErrors.AntragstellerTelefon}
                  onBlur={commonCode.ValidateOnBlur.bind(this)}
                />
              </Col>
            </Row>
        </React.Fragment>
    )
}